import React from 'react'

const DEFAULT_TYPE_OPTIONS = [
  { value: 'text', label: '텍스트' },
  { value: 'textarea', label: '긴 텍스트' },
  { value: 'tel', label: '전화번호' },
  { value: 'select', label: '선택' },
  { value: 'radio', label: '라디오' },
  { value: 'checkbox', label: '체크박스' },
  { value: 'number', label: '숫자' },
  { value: 'date', label: '날짜' },
]

export default function CategoryLandingFieldListEditor({
  title,
  items = [],
  onChange,
  keyName = 'name',
  keyLabel,
  addLabel,
  createItem,
  typeOptions = DEFAULT_TYPE_OPTIONS,
  showPlaceholder = true,
  showOptions = true,
}) {
  const normalizedKeyLabel = keyLabel || (keyName === 'name' ? '필드 키' : '질문 ID')

  const updateItems = (next) => {
    onChange?.(next)
  }

  return (
    <div className="rounded-xl border p-4 space-y-3 bg-white">
      <div className="flex items-center justify-between">
        <div className="font-semibold text-sm">{title}</div>
        <button
          type="button"
          className="rounded border px-2 py-1 text-xs"
          onClick={() => updateItems([...(items || []), createItem ? createItem(items) : {}])}
        >
          {addLabel}
        </button>
      </div>
      <div className="space-y-2">
        {(items || []).map((field, idx) => {
          const key = field?.[keyName] || `${keyName}_${idx}`
          const type = String(field?.type || 'text')
          const allowOptions = showOptions && (type === 'select' || type === 'radio' || type === 'checkbox')
          return (
            <div key={key} className="rounded-lg border p-3 space-y-2">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                <div>
                  <label className="text-xs text-slate-500">{normalizedKeyLabel}</label>
                  <input
                    className="mt-1 w-full rounded border px-2 py-2 text-sm"
                    value={field?.[keyName] || ''}
                    onChange={(e) => {
                      const next = [...items]
                      next[idx] = { ...next[idx], [keyName]: e.target.value }
                      updateItems(next)
                    }}
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-500">라벨</label>
                  <input
                    className="mt-1 w-full rounded border px-2 py-2 text-sm"
                    value={field?.label || ''}
                    onChange={(e) => {
                      const next = [...items]
                      next[idx] = { ...next[idx], label: e.target.value }
                      updateItems(next)
                    }}
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-500">타입</label>
                  <select
                    className="mt-1 w-full rounded border px-2 py-2 text-sm"
                    value={type}
                    onChange={(e) => {
                      const next = [...items]
                      next[idx] = { ...next[idx], type: e.target.value }
                      updateItems(next)
                    }}
                  >
                    {typeOptions.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                </div>
                <div className="flex items-end justify-between gap-2">
                  <label className="flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      checked={Boolean(field?.required)}
                      onChange={(e) => {
                        const next = [...items]
                        next[idx] = { ...next[idx], required: e.target.checked }
                        updateItems(next)
                      }}
                    />
                    필수
                  </label>
                  <button
                    type="button"
                    className="rounded border border-red-300 px-2 py-1 text-xs text-red-600"
                    onClick={() => {
                      const next = [...items]
                      next.splice(idx, 1)
                      updateItems(next)
                    }}
                  >
                    삭제
                  </button>
                </div>
              </div>
              {(showPlaceholder || allowOptions) && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {showPlaceholder ? (
                    <div>
                      <label className="text-xs text-slate-500">플레이스홀더</label>
                      <input
                        className="mt-1 w-full rounded border px-2 py-2 text-sm"
                        value={field?.placeholder || ''}
                        onChange={(e) => {
                          const next = [...items]
                          next[idx] = { ...next[idx], placeholder: e.target.value }
                          updateItems(next)
                        }}
                      />
                    </div>
                  ) : <div />}
                  {allowOptions && (
                    <div>
                      <label className="text-xs text-slate-500">옵션(쉼표 구분)</label>
                      <input
                        className="mt-1 w-full rounded border px-2 py-2 text-sm"
                        value={Array.isArray(field?.options) ? field.options.join(', ') : ''}
                        onChange={(e) => {
                          const next = [...items]
                          next[idx] = {
                            ...next[idx],
                            options: e.target.value.split(',').map((v) => v.trim()).filter(Boolean),
                          }
                          updateItems(next)
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
